
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M17.734 6.275a.906.906 0 00-1.283 0L12 10.717l-4.45-4.45a.906.906 0 10-1.284 1.282L10.716 12l-4.45 4.45a.906.906 0 101.283 1.284L12 13.284l4.45 4.45a.906.906 0 101.284-1.283L13.284 12l4.45-4.45a.912.912 0 000-1.275z","fill":"#23262D","fill-rule":"nonzero"}})])])
          )
        }
      }
    